import { createContext } from 'react';
import { RequestModel } from '../di/models/RequestModel';
import { RequestHeaderProps } from '@platform/ics-front-core';

export type RequestHeaderContextType = Pick<RequestHeaderProps, 'onModalOpen' | 'reloadIncrement'> & {
    requestModel: RequestModel;
};

export const RequestHeaderContext = createContext<RequestHeaderContextType>({} as RequestHeaderContextType);
